import React from "react";
import { WrappedFieldProps } from "redux-form";
import { Input, FormFeedback } from "reactstrap";

import { FormGroup } from "../FormGroup";

interface FormInputProps {
    name: string;
    label: string;
    type?: string;
    disabled?: boolean;
    id?: string;
    placeholder?: string;
    showLabel?: boolean;
}

function FormInput(props: WrappedFieldProps & FormInputProps): JSX.Element {
    const {
        input,
        name,
        disabled,
        label,
        type,
        id,
        placeholder,
        showLabel,
        meta: { error, touched },
    } = props;

    // Sort the group props
    const hasError = touched && error != null;
    const groupProps: any = {
        label,
        hasError,
        showLabel,
    };
    // And the input props.
    const inputProps: any = {
        name,
        type: type ? type : "text",
        disabled,
        invalid: hasError,
    };
    if (id != null) {
        groupProps.htmlFor = id;
        inputProps.id = id;
    }
    if (placeholder != null) {
        inputProps.placeholder = placeholder;
    }
    if (hasError) {
        inputProps.valid = false;
    }
    return (
        <FormGroup {...groupProps}>
            <Input {...inputProps} {...input} />
            {hasError && <FormFeedback>{error}</FormFeedback>}
        </FormGroup>
    );
}

export { FormInput };
